import React from 'react';
import SEO from '../components/molecules/SEO'
import Container from '../components/atoms/Container';
import EnquireForm from '../components/organisms/EnquireForm';
import styled from 'styled-components';

const Holder = styled.div`
  background-color: ${props => props.theme.colours.grey};
  padding: 4rem 0;
`;

const Inner = styled.div`
  h2 { text-align: center; }
  @media( ${props => props.theme.breakpoints.lg} ) {
    margin: 0 4rem;
  }
`;

const Enquire = () => (
  <>
    <SEO title="Enquire"/>
    <Holder>
      <Container>
        <Inner>
          <EnquireForm/>
        </Inner>
      </Container>
    </Holder>
  </>
);

export default Enquire;
